import { useState } from 'react';
import type { FillExercise, FillResult } from '../../core/exercises.ts';
import { PromptText } from './PromptText.tsx';

export function FillView({
  exercise,
  values,
  onChange,
  result,
}: {
  exercise: FillExercise;
  values: string[];
  onChange: (value: string[]) => void;
  result: FillResult | null;
}) {
  const set = (index: number, value: string) =>
    onChange(exercise.blanks.map((_, i) => (i === index ? value : values[i] ?? '')));
  const slotState = (i: number) => (result ? (result.perBlank[i] ? ' slot--correct' : ' slot--wrong') : '');

  // The translation stays hidden until asked for (or the answer is checked).
  const [showRu, setShowRu] = useState(false);
  const hint = exercise.promptRu ? (
    showRu || result ? (
      <p className="t-meta prompt__ru">{exercise.promptRu}</p>
    ) : (
      <button type="button" className="btn btn--text prompt__ru-toggle" onClick={() => setShowRu(true)}>
        Перевод
      </button>
    )
  ) : null;

  if (exercise.bank) {
    const nextEmpty = exercise.blanks.findIndex((_, i) => !values[i]);
    return (
      <div className="stack stack--24">
        <PromptText
          text={exercise.prompt}
          renderBlank={(i) => (
            <button
              type="button"
              className={`slot${values[i] ? ' slot--filled' : ''}${slotState(i)}`}
              disabled={result !== null || !values[i]}
              onClick={() => set(i, '')}
              aria-label={values[i] ? `Убрать «${values[i]}»` : `Пропуск ${i + 1}`}
            >
              {values[i] ?? ''}
            </button>
          )}
        />
        {hint}
        <div className="bank" aria-label="Слова для вставки">
          {exercise.bank.map((word) => (
            <button
              key={word}
              type="button"
              className="tile tile--word"
              disabled={result !== null || nextEmpty === -1 || values.includes(word)}
              onClick={() => set(nextEmpty, word)}
            >
              {word}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="stack">
      <PromptText
        text={exercise.prompt}
        renderBlank={(i) => (
          <input
            className={`slot slot--input${slotState(i)}`}
            value={values[i] ?? ''}
            onChange={(e) => set(i, e.target.value)}
            disabled={result !== null}
            aria-label={`Пропуск ${i + 1}`}
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck={false}
            size={Math.max(4, (exercise.blanks[i]?.[0] ?? '').length + 2)}
          />
        )}
      />
      {hint}
    </div>
  );
}
